<template>
	<wrapper-readonly-modes
		:blockDefinitions="blockDefinitions"
		:blocks="blocks"
		:canStartPresenterMode="canStartPresenterMode"
		canvasClass="p-block-viewer-canvas"
		:defaultBlockStyles="defaultBlockStyles"
		:globalVariables="globalVariables"
		:leftPanelsBottom="leftPanelsBottom"
		:leftPanelsTop="leftPanelsTop"
		:mode="mode"
		modeClass="lp-index-viewer"
		:rightPanels="rightPanels"
		:settingStyles="settingStyles"
		:slideId="slideId"
		@selectSlideById="onSelectSlideById"
		@goToBookmarkTarget="onGoToBookmarkTarget"
		@slideChanged="onSlideChanged"
	/>
</template>

<script>
import WrapperReadonlyModes from '../WrapperReadonlyModes.vue';

export default {
	name: 'BlockViewer',
	components: {
		WrapperReadonlyModes
	},
	props: {
		blocks: Array,
		slideId: String,
		blockDefinitions: Object,
		defaultBlockStyles: Object,
		settingStyles: Object,
		leftPanelsTop: Array,
		leftPanelsBottom: Array,
		rightPanels: Array,
		globalVariables: Array,
		mode: String,
		canStartPresenterMode: Boolean
	},
	methods: {
		onSelectSlideById(id) {
			this.$emit('selectSlideById', id);
		},
		onGoToBookmarkTarget(bookmark) {
			this.$emit('goToBookmarkTarget', bookmark);
		},
		onSlideChanged(blocksSelector) {
			this.$emit('slideChanged', blocksSelector);
		}
	}
};
</script>

<style>
.lp-index-viewer .lp-index-panel {
	top: 0;
}

.lp-index-viewer .lp-index-main {
	top: 0;
}
</style>
